/**
 * recent.js — DEMO "Bạn đã xem gần đây" ở trang chi tiết sản phẩm.
 *
 * Markup: section[data-recent][hidden] chứa ul[data-recent-list], button[data-recent-clear] và
 *         <template data-recent-template> (một <li> có [data-recent-image] [data-recent-name]
 *         [data-recent-meta] [data-recent-price]). Id sản phẩm đang xem lấy từ
 *         [data-product][data-product-id] đầu tiên của trang.
 *
 * Vì sao:
 *   · Khung thẻ nằm trong <template> ở HTML chứ không dựng chuỗi trong JS — đổi markup chỉ sửa
 *     một chỗ, giống cách PHP sẽ in.
 *   · Dữ liệu thẻ (tên, ảnh, giá) tra từ window.WBCatalog (catalog.js) theo id — catalog.js nạp
 *     TRƯỚC file này (gulp gộp theo chữ cái) nên đọc được ngay.
 *   · Chai đang xem không hiện trong danh sách của chính nó; ghi vào đầu lịch sử SAU khi vẽ.
 *     Lần đầu mở (chưa có lịch sử) gieo sẵn vài chai để bản tĩnh có cái mà xem.
 *
 * WP: XOÁ file này. Cookie woocommerce_recently_viewed + wc_get_products( [ 'include' => ids ] ).
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var KEY = 'wb_recent';
    var MAX = 8;
    var SEED = ['barolo-riserva', 'cloudy-bay-sauvignon', 'moet-brut', 'penfolds-bin-389'];

    var section = document.querySelector('[data-recent]');
    if (!section || !window.WBCatalog) return;

    var list = section.querySelector('[data-recent-list]');
    var tpl = section.querySelector('[data-recent-template]');
    var clear = section.querySelector('[data-recent-clear]');
    var holder = document.querySelector('[data-product][data-product-id]');
    var currentId = holder ? holder.getAttribute('data-product-id') : '';
    if (!list || !tpl || !tpl.content) return;

    function read() {
        try {
            var raw = window.localStorage.getItem(KEY);
            return raw === null ? SEED.slice() : JSON.parse(raw) || [];
        } catch (e) {
            return [];
        }
    }

    function write(ids) {
        try {
            window.localStorage.setItem(KEY, JSON.stringify(ids.slice(0, MAX)));
        } catch (e) {
            // Chế độ ẩn danh / hết dung lượng: bỏ qua, khối chỉ không nhớ được lần sau
        }
    }

    function money(value) {
        return Math.round(Number(value) || 0).toLocaleString('vi-VN') + '₫';
    }

    function render(ids) {
        list.innerHTML = '';
        ids.forEach(function (id) {
            if (id === currentId) return;
            var p = window.WBCatalog.get(id);
            if (!p) return;
            var node = tpl.content.cloneNode(true);
            var link = node.querySelector('a');
            var img = node.querySelector('[data-recent-image]');
            if (link) link.setAttribute('href', p.url);
            if (img) img.setAttribute('src', p.image);
            node.querySelector('[data-recent-name]').textContent = p.name;
            node.querySelector('[data-recent-meta]').textContent = p.meta;
            node.querySelector('[data-recent-price]').textContent = money(p.price);
            list.appendChild(node);
        });
        section.hidden = !list.children.length;
    }

    var ids = read();
    render(ids);

    // Ghi chai đang xem lên đầu lịch sử (bỏ bản trùng)
    if (currentId) {
        write([currentId].concat(ids.filter(function (id) {
            return id !== currentId;
        })));
    }

    if (clear) {
        clear.addEventListener('click', function () {
            write(currentId ? [currentId] : []);
            render([]);
        });
    }
})();
